import Logger from '@vaersaagod/tools/Logger';

export class BaseComponent {

    state = {};
    Logger = null;

    constructor(el, props = {}, state = null) {

        this.id = Math.random() * new Date().getTime();
        this.el = el;

        /*
         *   The `props` object is collected from a JSON hash in the component element's `data-component-props` attribute
         *
         */
        this.props = Object.assign({
            hot: true
        }, props);

        /*
         *   Hydrate the initial state. This is not React; the `state` object is mostly used to retain data across HMR reinitializations
         *   this.setState({foo: 'bar'}); can be a useful way to set stateful attributes, tho – TODO as well
         *
         */
        if (state) {
            this.state = Object.assign({}, this.state, state);
        }

        this.logger = Logger.getLogger(this.constructor.name);

        this.init();

    }

    /*
     *
     *
     */
    init() {}

    /*
     *   Let's clean up after ourselves
     *
     */
    destroy() {
        delete this.el;
        delete this.props;
    }

    /*
     *   Store something in the component's state
     *
     */
    setState(state, cb) {
        this.state = Object.assign({}, this.state, state);
        this.onStateChanged();
        if (cb) cb();
    }

    /*
     *   Hooks
     *
     */

    // Called just before the component is replaced and destroyed via HMR
    beforeDispose() {}

    // Called whenever the state is changed
    onStateChanged() {}

}

export default BaseComponent;



// WEBPACK FOOTER //
// ./src/js/lib/BaseComponent.js